<template>
  <div id="notice-intro">
    <div>
      <comp-header
        :leftIcon="headerLeftIcon"
        :headerPosition="headerPos"
        :pageTitle="headerPageTitle"
        :leftClick="goPrevious"
      />
    </div>
    <div>
      <router-view id="notice-router"></router-view>
    </div>
  </div>
</template>

<script>
import CompHeader from '@/components/CompHeader';
import common from '@/utils/common';

export default {
  name: 'notice-intro',
  mixins: [
    common,
  ],
  data() {
    return {
      tab: 'home',
      headerPos: 'on-top',
      headerLeftIcon: 'fa-chevron-left',
      headerPageTitle: this.$i18n.t('myMenu.notice'),
    };
  },
  components: {
    CompHeader,
  },
  mounted() {
    this.isShowMenu(false);
  },
};
</script>

<style lang="scss" src="../../scss/notice-intro.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/notice/notice-intro.vue